// extracted by mini-css-extract-plugin
export var container = "_404-module--container--p0jQK";
export var topPageButton = "_404-module--topPageButton--2UnCy";
export var title = "_404-module--title--2sRC_";
export var message = "_404-module--message--AuAvI";